export default {
    state: {
      // 属性
      showWeatherIcons: true,
      timeGrid: new Date().getHours(),
      isWind: false,
      isWaves: false,
      isCurrent: false,
      isPlay: false
    },
    getters: {
        showWeatherIcons: state => state.showWeatherIcons,
        timeGrid: state => state.timeGrid,
        isWind: state => state.isWind,
        isWaves: state => state.isWaves,
        isCurrent: state => state.isCurrent,
        isPlay: state => state.isPlay
    },
    mutations: {
      // set方法
      setShowWeatherIcons (state, v) {
        state.showWeatherIcons = v
      },
      setTimeGrid (state, v) {
        state.timeGrid = v
      },
      setIsWind (state, v) {
        state.isWind = v
      },
      setIsWaves (state, v) {
        state.isWaves = v
      },
      setIsCurrent (state, v) {
        state.isCurrent = v
      },
      setIsPlay (state, v) {
        state.isPlay = v
      }
    },
    actions: {
      SET_SHOW_WEATHER_ICONS ({ commit }, value) {
        commit('setShowWeatherIcons', value)
      },
      SET_TIME_GRID ({ commit }, value) {
        commit('setTimeGrid', value)
      },
      SET_IS_WIND ({ commit }, value) {
        commit('setIsWind', value)
      },
      SET_IS_WAVE ({ commit }, value) {
        commit('setIsWaves', value)
      },
      SET_IS_CURRENT ({ commit }, value) {
        commit('setIsCurrent', value)
      },
      SET_IS_PLAY ({ commit }, value) {
        commit('setIsPlay', value)
      }
    }
  }